import { combineReducers } from 'redux';
import UtilsReducer from './utils';


export default combineReducers({
    utils: UtilsReducer
});
